import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { putawayAppPath } from 'src/components/Navbar';

// Sends a signed-in user to Putaway from any other page, whichever page the
// auth flow lands on. Child pages under /putaway-app stay reachable.
export const useLockToPutaway = (lock: boolean): void => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!lock || isLoading || !isAuthenticated) return;
    // Don't move while Auth0 is still consuming its redirect params, or we'd
    // strip ?code/?state before the callback is processed.
    if (/[?&](code|state|error)=/.test(window.location.search)) return;
    if (!pathname.startsWith(putawayAppPath)) {
      navigate(putawayAppPath, { replace: true });
    }
  }, [lock, isAuthenticated, isLoading, pathname, navigate]);
};
